import { all, call, put, takeLatest } from "redux-saga/effects";
import { db } from "../../common/lib";
import { actionCreators, actionTypes } from "./actions";
import { get, update } from "idb-keyval";
import { logToSentry } from "../../config/Sentry";

function* select(action) {
    const { auditId } = action.payload;
    try {
        let altAssets = (yield call(get, db.types.altAsset)) || [];
        /** filter the alt asset based on the auditId */
        const currentAssets = altAssets.filter(
            (item) => item.audit.id === parseInt(auditId)
        );
        yield put(actionCreators.selectSuccess(currentAssets));
    } catch (error) {
        const errStr = error.toString();
        logToSentry("alt asset select", {
            error,
            errStr,
            actionPayload: action.payload,
        });
        yield put(actionCreators.selectFailure(errStr));
    }
}

function* write(action) {
    const { altAssets } = action.payload;
    try {
        yield call(update, db.types.altAsset, (altAssetsDB = []) => {
            if (!altAssetsDB) altAssetsDB = [];
            return [...altAssetsDB, altAssets[0]];
        });

        yield put(actionCreators.writeSuccess(altAssets[0]));
    } catch (error) {
        const errStr = error.toString();
        logToSentry("alt asset write", {
            error,
            errStr,
            actionPayload: action.payload,
        });
        yield put(actionCreators.writeFailure(errStr));
    }
}

export { select, write };

export default (function* () {
    yield all([
        takeLatest(actionTypes.ALT_ASSETS_SELECT_REQUEST, select),
        takeLatest(actionTypes.ALT_ASSETS_WRITE_REQUEST, write),
    ]);
})();
